import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BASE_URL } from "../constant";
import { useSelector } from "react-redux";
export const fetchCart = createAsyncThunk("cart/fetchCart", async (userId, thunkAPI) => {
    const state = thunkAPI.getState()
    const access_token = state.User.access_token
    const response = await fetch(`${BASE_URL}api/v1/payment/get-cart-details/${userId}`,{
        method: 'GET',
        headers:{Authorization:'Bearer '+ access_token}
    });
    const data = await response.json();

    return data;
});


const calculateCost = (items, wallet_adjustment = 0) => {
    const base_rate = items.reduce((sum, item) => sum + parseFloat(item.cost), 0);
    const tax = base_rate * 0.18;
    const total_amount_payable = base_rate + tax;

    const adjusted_wallet = Math.min(wallet_adjustment, total_amount_payable);
    const final_amount = total_amount_payable - adjusted_wallet;

    return {
        base_rate: parseFloat(base_rate.toFixed(2)),
        tax: parseFloat(tax.toFixed(2)),
        total_amount_payable: parseFloat(total_amount_payable.toFixed(2)),
        wallet_adjustment: parseFloat(adjusted_wallet.toFixed(2)),
        final_amount: parseFloat(final_amount.toFixed(2)),
    };
};


const CartSlice = createSlice({
    name: "cart",
    initialState: {
        items: [], // Array of unique items { id, name, price }
        cost: {
            base_rate: 0,
            tax: 0,
            total_amount_payable: 0,
            wallet_adjustment: 0,
            final_amount: 0,
        },
        wallet: {
            balance: 0.0,
            credits: 0.0,
            currency: "INR"
        },
        status: "idle",
    },
    reducers: {
        addItem: (state, action) => {
            state.items.push(action.payload);
            state.cost = calculateCost(state.items, state.cost.wallet_adjustment);
        },
        removeItem: (state, action) => {
            const itemToRemove = action.payload;
            state.items = state.items.filter(
                (item) =>
                    !(
                        item.issuer_name === itemToRemove.issuer_name &&
                        item.holder_email === itemToRemove.holder_email &&
                        item.document_name === itemToRemove.document_name
                    )
            );
            state.cost = calculateCost(state.items, state.cost.wallet_adjustment);

        },
        updateCost: (state, action) => {
            state.cost = action.payload;
        },
        clearCart: (state) => {
            state.items = [];
            state.cost = {
                base_rate: 0,
                tax: 0,
                total_amount_payable: 0,
                wallet_adjustment: 0,
                final_amount: 0,
            };
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCart.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchCart.fulfilled, (state, action) => {
                state.items = action.payload.data.items;
                state.cost = action.payload.data.cost;
                state.wallet = action.payload.data.wallet;
                state.user=action.payload.data.user
                state.status = "success";
            })
            .addCase(fetchCart.rejected, (state) => {
                state.status = "error";
            });
    },
});

export const { addItem, removeItem, updateCost, clearCart } = CartSlice.actions;

export default CartSlice.reducer;
